import { render, staticRenderFns } from "./FertilizerProgramTables.vue?vue&type=template&id=72a1d641&"
import script from "./FertilizerProgramTables.vue?vue&type=script&lang=js&"
export * from "./FertilizerProgramTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports